<template>
  <div
    id="context_menu"
    class="context_menu_container"
    :style="{
      top: `${topPosition}px`,
      left: `${leftPosition}px`,
    }"
  >
    <div
      v-for="item in data"
      v-if="item.condition"
      :id="item.id"
      :key="item.id"
      class="menu_item"
      @click.stop="
        item.handler(...handlerArgs)
        onClickHandler()
      "
    >
      <font-awesome-icon
        :title="item.label"
        :class="item.iconClasses"
        :icon="item.iconType"
      />
      <span :style="{marginLeft: isDeleteField(item) ? '1px' : 0}">
        {{ item.label }}
      </span>
    </div>
  </div>
</template>
<script>

export default {
  name: 'ComplexTableContextMenu',
  props: [
    'isEditable',
    'isCheckActive',
    'isDeletable',
    'isOpen',
    'top',
    'left',
    'tableItem',
    'onEdit',
    'onDelete',
    'onConfirm',
    'onHistory',
    'idx',
    'isReadOnly',
  ],
  data() {
    return {
      handlerArgs: [this.tableItem, this.idx, {
        key: 'actions',
        label: 'Actions',
        tdClass: 'align-top',
        thClass: 'text-center',
        thStyle: {width: '150px'},
      }],
      data: [
        {
          id: 'context_menu_confirm_field',
          condition: this.isCheckActive,
          label: 'Confirm',
          iconClasses: 'text-success action-button',
          iconType: ['fas', 'check'],
          handler: this.onConfirm,
        },
        {
          id: 'context_menu_edit_field',
          condition: this.isEditable,
          label: 'Edit',
          iconClasses: 'text-primary action-button',
          iconType: ['fas', 'edit'],
          handler: this.onEdit,
        },
        {
          id: 'context_menu_delete_field',
          condition: this.isDeletable,
          label: 'Delete',
          iconClasses: 'text-danger action-button',
          iconType: ['fas', 'trash'],
          handler: this.onDelete,

        },
        {
          id:'context_menu_history_field',
          condition: true,
          label: 'History',
          iconClasses: 'text-warning action-button ',
          iconType: ['fas', 'history'],
          handler: this.onHistory,
        },
      ],
    };
  },
  computed: {
    XPosition() {
      const clientWidth = window.innerWidth;
      const middle  = clientWidth / 2;
      return (this.left < clientWidth - middle / 3) ? 'left' : 'right';
    },
    YPosition() {
      const clientHeight = window.innerHeight;
      const middle  = clientHeight / 2;
      return (this.top > clientHeight - middle / 2) ? 'bottom' : 'top';
    },
    leftPosition() {
      return this.XPosition === 'left' ? this.left : (this.left - 110);
    },
    topPosition() {
      return this.YPosition === 'top' ? (this.top + 20) : (this.top - 140);
    },
  },
  methods: {
    onClickHandler() {
      const menu = document.getElementById('context_menu');
      if(!menu) return;
      menu.style.display = 'none';
    },
    isDeleteField(item) {
      return item.label === 'Delete';
    },
    onOutsideClick(e) {
      e.stopPropagation();
      const target = e.target;
      if (!target.classList.contains('context_menu_container')) {
        this.$emit('on-outside-click');
      }
    },
  },
  mounted() {
    window.addEventListener('click', this.onOutsideClick);
  },
  beforeUnmount() {
    window.removeEventListener('click', this.onOutsideClick);
  },
};
</script>

<style scoped lang="scss">
.context_menu_container {
  border-radius: 6px;
  box-shadow: 0 0 5px #0F355E;
  width: 110px;
  position: fixed;
  z-index: 10;
  font-size: 1.1em;
  padding: 10px 0;
  background-color: #fff;
}

.menu_item {
  display: flex;
  align-items: center;
  gap: 20px;
  cursor: pointer;
  transition: 0.4s;
  padding: 5px 10px;

  &:hover {
    background-color: #eee;
  }
}
</style>